<template>
  <div class="proyecto-content body-container v-application">
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        
      >
        <v-card-text>
         <div class="loadTitle">
        <img :src="images.logo" /> <label>Cargando...</label>
        </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <section class="proyecto">
      <div class="proyecto-title">
        <h2 v-if="proyectSelected">
          <span class="bricsa-square"></span>Proyecto seleccionado
        </h2>
        <h2 v-else>
          <span class="bricsa-square"></span>Selecciona tu proyecto
        </h2>
      </div>
      <div class="proyecto-group">
        <!-- Falta que al seleccionar un proyecto, sólo se muestre ese -->
        <v-progress-linear
            indeterminate
            color="green"
            v-show="projects.proyectos.length==0"
          ></v-progress-linear>
        <div
          v-for="(proy, index) in projects.proyectos"
          :key="index"
          @click="proyectSelected = proy.sci;proyectoSeleccionado=proy"
        > 
          <div :class="proyectSelected==null?'':proyectSelected==proy.sci?'selected':'unselected'" class="proyecto-item" v-if="proy.imagen!='https://www.bricsa.cl/wp-content/uploads/'">
            <img :src="proy.imagen"/>
          </div>
        </div>
      </div>
    </section>
    <section class="share">
      <b-form class="form-signinx d-flex align-items-stretch flex-column" autocomplete="off" @submit="onSubmit">
      <div class="share-title">
        <h2><span class="bricsa-square"></span>Compartir</h2>
      </div>
      <div class="share-form">
         <div
              role="alert" v-show="errors.length>0"
              v-bind:class="{ show: errors.length }"
              class="alert alert-danger"
            >
              <div class="alert-text" v-for="(error, i) in errors" :key="i">
                {{ error }}
              </div>
            </div>
        <v-alert v-show="form_show"
      outlined
      :type="result_type"
      text
    >
      Gracias. Hemos recibido correctamente su solicitud.
    </v-alert>
        <div class="row">
                                                            <div class="form-group col-md-12">
                                                                <label>*RUT</label>
                                                                <b-form-input
                    class="form-control"
                    id="info-rut"
                    name="rut"
                    v-model="$v.form.rut.$model"
                    :state="validateState('rut')"
                    aria-describedby="info-rut-mensaje-validacion"
                    placeholder="Ingrese Rut"
                    type="text"
                    maxLength="10"
                  ></b-form-input>

                  <b-form-invalid-feedback
                    id="info-rut-mensaje-validacion"
                  >Ingrese Rut. Sin puntos y con -</b-form-invalid-feedback> 
                                                            </div>
                                                            <div class="form-group col-md-12">
                                                                <label>*Nombre</label>
                                                                <b-form-input
                  class="form-control"
                  id="info-nombre"
                  name="nombre"
                  v-model="$v.form.nombre.$model"
                  :state="validateState('nombre')"
                  aria-describedby="info-nombre-mensaje-validacion"
                  placeholder="Nombre"
                  type="text"
                  maxLength="75"
                ></b-form-input>

                <b-form-invalid-feedback
                  id="info-nombre-mensaje-validacion"
                >El nombre es obligatorio.</b-form-invalid-feedback>

                                                            </div>
                                                            <div class="form-group col-md-12">
                                                                <label>*Apellido</label>
                                                                <b-form-input
                  class="form-control"
                  id="info-apellidoPaterno"
                  name="apellidoPaterno"
                  v-model="$v.form.apellidoPaterno.$model"
                  :state="validateState('apellidoPaterno')"
                  aria-describedby="info-apellidoPaterno-mensaje-validacion"
                  placeholder="Apellido Paterno"
                  type="text"
                  maxLength="75"
                ></b-form-input>

                <b-form-invalid-feedback
                  id="info-apellidoPaterno-mensaje-validacion"
                >El Apellido Paterno es obligatorio.</b-form-invalid-feedback>
                                                            </div>
                                                            
                                                            
                                                            <div class="form-group col-md-12">
                                                                <label>*Correo electrónico</label>
                                                                 <b-form-input
                    class="form-control"
                    id="info-email"
                    name="email"
                    v-model="$v.form.email.$model"
                    :state="validateState('email')"
                    aria-describedby="info-email-mensaje-validacion"
                    placeholder="Email"
                    type="email"
                    maxLength="75"
                  ></b-form-input>

                  <b-form-invalid-feedback
                    id="info-email-mensaje-validacion"
                  >Email es obligatorio Ej: correo@gmail.com.</b-form-invalid-feedback>
                                                            </div>
                                                            
                                                            <div class="form-group col-md-12">
                                                                <label for="Telefono">*Teléfono</label>
                                                                <div class="input-group">
                                                                    <div class="input-group-prepend">
                                                                        <span class="input-group-text" id="prefijo">+56</span>
                                                                    </div>
                                                                    <b-form-input
                    class="form-control"
                    id="info-celular"
                    name="celular"
                    v-model="$v.form.celular.$model"
                    :state="validateState('celular')"
                    aria-describedby="info-movil-mensaje-validacion"
                    placeholder="Celular"
                    type="number"
                    maxLength="9"
                  ></b-form-input>

                  <b-form-invalid-feedback
                    id="info-celular-mensaje-validacion"
                  >Celular es obligatorio y no debe superar los 9 dígitos, Ej:991234567</b-form-invalid-feedback> 
                                                                </div>
                                                            </div>
                                                        </div>

       
        <b-button  ref="kt_login_signin_submit" @click="onSubmit" :disabled="proyectSelected==null"
                                                class="btn btn-primary align-self-center">Compartir</b-button>
      </div>
      </b-form>
    </section>
    <section class="referidos">
      <div class="referidos-title">
        <h2><span class="bricsa-square"></span>Estado de mis referidos</h2>
      </div>
      <div class="referidos-list">
        <b-table
          :mobile-cards="hasMobileCards"
          :striped="isStriped"
          :data="referidos.referidos"
          :columns="columns"
          :selected.sync="selected"
          focusable
        ></b-table>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { rutEsValido } from "@/core/validators/rut.js"
import { validationMixin } from "vuelidate";
import { minLength, required, email, numeric} from "vuelidate/lib/validators";
import moment from 'moment'
moment.locale( 'es' );
import { CREATE_REFERIDO, GET_REFERIDOS } from "@/core/services/store/referido.module";
import { GET_PROJECTOS_WP, GET_MODELOS_WP } from "@/core/services/store/proyecto.module";
export default {
  mixins: [validationMixin],
  data() {
    return {
      images: {
                family: process.env.BASE_URL + 'media/family.jpg',
                logo: process.env.BASE_URL +'media/logo.png',
            },
      loading: true,
      isLoading:false,
      form_show:false,
      result_type:"success",
      form: {
        rut:null,
        nombre:null,
        apellidoPaterno:null,
        email:null,
        celular:null,
      }
      ,
      selected: {},
      hasMobileCards: false,
      isStriped: true,
      proyectSelected: null,
      proyectoSeleccionado:null,
      columns: [
        { field: "fecha", label: "Fecha" },
        { field: "proyecto", label: "Proyecto" },
        {
          field: "nombre",
          label: "Nombre",
        },
        { field: "estado", label: "Estado" },
      ],
    };
  },
  validations: {
    form: {
      rut: {
        required,
        rutEsValido
      },
      nombre: {
        required,
        minLength: minLength(3)
      },
      apellidoPaterno: {
        required,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      },
      celular: {
        required,
        minLength: minLength(9),
        numeric
      }
    }
  },

  mounted () {
    this.getProjects();
    this.getReferidos();
  },
  filters:{
    formatDate(value) {
        const duration = moment(value).format('DD/MM/yyyy');
        return `${duration}`;
    },

    formatTime(value) {
        const hora = moment(value).format('HH:mm:ss');
        return `${hora}`;
    }
  },
  methods: {
    info(value) {
      this.test = value;
    },
    getProjects() {
      this.$Progress.start();
      this.projects.proyectos=[];
      this.$store
          .dispatch(GET_PROJECTOS_WP, null)
          .then(()=>{
            this.$Progress.finish();
            this.loading=false;
      });
    },
    getReferidos() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_REFERIDOS, null)
          .then(()=>{
            this.$Progress.finish()
      });
    },
    obtenerModelos(proy){
        this.proyectSelected = proy.url;
        this.$Progress.start();
        this.$store
            .dispatch(GET_MODELOS_WP, proy.url)
            .then(()=>{
                this.$Progress.finish()
        });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        rut: null,
        nombre: null,
        apellidoPaterno:null,
        email:null,
        celular:null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      console.log('hay errores ' + this.$v.form.$anyError);
      if (this.$v.form.$anyError) {
        return;
      }

      const rut = this.$v.form.rut.$model;
      const nombre = this.$v.form.nombre.$model + ' ' + this.$v.form.apellidoPaterno.$model
      const email = this.$v.form.email.$model;
      const idProyecto = this.proyectSelected;
      const telefono = this.$v.form.celular.$model;
      const proyecto = this.proyectoSeleccionado.name;
      // set spinner to submit button
    //  const submitButton = this.$refs["kt_login_signin_submit"];
     // submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      const t = this;
      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(CREATE_REFERIDO, { rut, nombre, email, telefono, idProyecto, proyecto })
          // go to which page after successfully login
          .then(() => {
            setTimeout(() => {
              window.scrollTo(50, 0);
            }, 100);
            if(t.errors.length==0){    
              this.form_show = true;
              this.resetForm();
              this.getReferidos();
            }
          });
      }, 500);
    }
  },
  computed: {
    ...mapState({
      errors: state => state.proyecto.errors,
      projects :state => state.proyecto.projectos_wp,
      referidos :state => state.referido.referidos,
      modelos :state => state.proyecto.modelos_wp
    }),
      rutErrors(){
        const errors = []
        if (!this.$v.form.rut) return errors
        !this.$v.form.rut.required && errors.push('Rut es requerido') 
        !this.$v.form.rut.rutEsValido && errors.push('Rut no es válido') 
        return errors
      },
      nombreErrors(){
        const errors = []
        if (!this.$v.form.nombre) return errors
        !this.$v.form.nombre.required && errors.push('Nombre es requerido') 
        !this.$v.form.nombre.minLength && errors.push('Al parecer el nombre es inválido') 
        return errors
      },
      paternoErrors(){
        const errors = []
        if (!this.$v.form.apellidoPaterno) return errors
        !this.$v.form.apellidoPaterno.required && errors.push('Apellido es requerido') 
        !this.$v.form.apellidoPaterno.minLength && errors.push('Al parecer el apellido es inválido') 
        return errors
      },
      
      celularErrors(){
        const errors = []
        if (!this.$v.form.celular) return errors
        !this.$v.form.celular.required && errors.push('Celular es requerido') 
        !this.$v.form.celular.minLength && errors.push('Celular debe contener 9 números') 
        !this.$v.form.celular.numeric && errors.push('Celular debe contener sólo números') 
        return errors
      },
      emailErrors(){
        const errors = []
        if (!this.$v.form.email) return errors
        !this.$v.form.email.required && errors.push('Email es requerido') 
        !this.$v.form.email.email && errors.push('Email no es válido') 
        return errors
      },
      
  }
};
</script>
<style>
.v-text-field.v-text-field--solo .v-input__control {
    min-height: 41px!important;
    padding: 0;
    border:none!important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    -webkit-box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 0px 0px 0px rgb(0 0 0 / 14%), 0px 0px 0px 0px rgb(0 0 0 / 12%)!important;
    box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 0px 0px 0px rgb(0 0 0 / 14%), 0px 0px 0px 0px rgb(0 0 0 / 12%)!important;
}
</style>
<style lang="scss" scoped>
.v-text-field.v-text-field--solo .v-input__control, .v-input__control  {
    min-height: 41px!important;
    padding: 0;
}
h2 {
  color: #707070;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  margin: 10px;
  margin-left: 0;
  display: flex;
  align-items: baseline;
  span {
    display: block;
    width: 15px;
    height: 15px;
    margin-right: 5px;
    background: var(--bricsa-red);
  }
}
.proyecto-content {
  padding: 3% 8%;
  @media screen and(max-width:1025px) {
    padding: 120px 5% 3%;
  }
}
.proyecto {
  .proyecto-title {
    button {
      background-color: transparent;
      border: none;
      color: var(--bricsa-red);
      font-weight: bold;
    }
  }
  .proyecto-group {
    padding: 3% 5%;
    display: grid;
    grid-template-columns: repeat(6, calc(95% / 6));
    justify-content: space-between;
    row-gap: 10px;
    @media screen and(max-width:1025px) {
      grid-template-columns: repeat(3, 32%);
    }

    .proyecto-item {
      background-color: var(--bricsa-red);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .unselected{
          opacity: 0.5;
    }
  }
}
.share {
  .share-form {
    width: 50%;
    display: grid;
    grid-template-columns: 100%;
    row-gap: 10px;
    margin: 3% 5%;
    padding: 20px;
    -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
    -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
    @media screen and(max-width:1024px){
      width: 90%;
    }

    .button {
      background-color: var(--bricsa-red);
      color: #fff;
      border-radius: 0;
      justify-self: flex-end;
    }
  }
}
.referidos {
  .referidos-list {
    padding: 3% 5%;
  }
}
</style>